@if ((queue$ | async); as queue) {
  @if (queue?.length > 0) {
    <ul @list>
      @for (download of queue; track download) {
        <li @items>
          <app-download-tray-item [item]="download"></app-download-tray-item>
        </li>
      }
    </ul>
  }
}
